var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 68,
    viewBox: "0 0 56 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9022 27.0982L49.8185 31.3636L51.7349 27.0982L56.0004 25.1818L51.7349 23.2655L49.8185 19L47.9022 23.2655L43.6367 25.1818L47.9022 27.0982Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3636 22.0908L30.5 30.5908L22 34.4545L30.5 38.3181L34.3636 46.8181L38.2273 38.3181L46.7273 34.4545L38.2273 30.5908L34.3636 22.0908ZM49.8182 37.5454L47.9018 41.8108L43.6364 43.7272L47.9018 45.6435L49.8182 49.909L51.7345 45.6435L56 43.7272L51.7345 41.8108L49.8182 37.5454Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 9H41",
    stroke: "white",
    strokeWidth: 3.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.5H38C38.8284 3.5 39.5 4.17157 39.5 5V17H43V5C43 2.23858 40.7614 0 38 0H5C2.23858 0 0 2.23858 0 5V63C0 65.7614 2.23858 68 5 68H38C40.7614 68 43 65.7614 43 63V51H39.5V63C39.5 63.8284 38.8284 64.5 38 64.5H5C4.17157 64.5 3.5 63.8284 3.5 63V5C3.5 4.17157 4.17157 3.5 5 3.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.de1621b1e051a423099c36ca52d4ba84.svg";
export { ForwardRef as ReactComponent };